var $eSX5Q$mqtt = require("mqtt");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c57"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c57"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b3Gr5", function(module, exports) {

var $crlg5 = parcelRequire("crlg5");

var $jKhzW = parcelRequire("jKhzW");

var $kgNDz = parcelRequire("kgNDz");

var $el3kn = parcelRequire("el3kn");

var $hWgEQ = parcelRequire("hWgEQ");
$parcel$exportWildcard(module.exports, $crlg5);
$parcel$exportWildcard(module.exports, $jKhzW);
$parcel$exportWildcard(module.exports, $kgNDz);
$parcel$exportWildcard(module.exports, $el3kn);
$parcel$exportWildcard(module.exports, $hWgEQ);

});
parcelRegister("crlg5", function(module, exports) {

$parcel$export(module.exports, "LATEST_VERSION", () => $90e87f2719fafcec$export$5bd6772f122cb888);
$parcel$export(module.exports, "DIGITAL", () => $90e87f2719fafcec$export$642ebf9ec2e6a14a);
$parcel$export(module.exports, "ANALOG", () => $90e87f2719fafcec$export$59b5878345794ac6);
// THIS INTERFACE WAS AUTO GENERATED ON 2025-07-26
// DO NOT EDIT THIS FILE.
// IT WILL BE OVERWRITTEN ON EVERY CELERYSCRIPT UPGRADE.
const $90e87f2719fafcec$export$5bd6772f122cb888 = 20180209;
const $90e87f2719fafcec$export$642ebf9ec2e6a14a = 0;
const $90e87f2719fafcec$export$59b5878345794ac6 = 1;

});

parcelRegister("jKhzW", function(module, exports) {

$parcel$export(module.exports, "Farmbot", () => $e5fff2f6d9c58e21$export$3ab9a2df6016a88a);

parcelRequire("el3kn");
var $d3ujF = parcelRequire("d3ujF");
var $2Wyna = parcelRequire("2Wyna");
var $bu5Qj = parcelRequire("bu5Qj");
parcelRequire("b3Gr5");
var $el3kn = parcelRequire("el3kn");

var $lYlQL = parcelRequire("lYlQL");

var $c7gS9 = parcelRequire("c7gS9");

var $7nBDP = parcelRequire("7nBDP");

var $g4iX8 = parcelRequire("g4iX8");

var $7L8KP = parcelRequire("7L8KP");

var $2Wyna = parcelRequire("2Wyna");
class $e5fff2f6d9c58e21$export$3ab9a2df6016a88a {
    constructor(input){
        /** Get a Farmbot Constructor Parameter. */ this.getConfig = (key)=>this.config[key];
        /** Set a Farmbot Constructor Parameter. */ this.setConfig = (key, value)=>{
            this.config[key] = value;
        };
        /**
         * Installs a "Farmware" (plugin) onto the bot's SD card.
         * URL must point to a valid Farmware manifest JSON document.
         */ this.installFarmware = (url)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "install_farmware",
                    args: {
                        url: url
                    }
                }
            ]));
        };
        /**
         * Checks for updates on a particular Farmware plugin when given the name of
         * a Farmware. `updateFarmware("take-photo")`
         */ this.updateFarmware = (pkg)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "update_farmware",
                    args: {
                        package: pkg
                    }
                }
            ]));
        };
        /** Uninstall a Farmware plugin. */ this.removeFarmware = (pkg)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "remove_farmware",
                    args: {
                        package: pkg
                    }
                }
            ]));
        };
        /**
         * Installs "Farmware" (plugins) authored by FarmBot, Inc.
         * onto the bot's SD card.
         */ this.installFirstPartyFarmware = ()=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "install_first_party_farmware",
                    args: {}
                }
            ]));
        };
        /**
         * Deactivate FarmBot OS completely (shutdown).
         * Useful before unplugging the power.
         */ this.powerOff = ()=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "power_off",
                    args: {}
                }
            ]));
        };
        /** Restart FarmBot OS. */ this.reboot = ()=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "reboot",
                    args: {
                        package: "farmbot_os"
                    }
                }
            ]));
        };
        /** Reinitialize the FarmBot microcontroller firmware. */ this.rebootFirmware = ()=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "reboot",
                    args: {
                        package: "arduino_firmware"
                    }
                }
            ]));
        };
        /** Check for new versions of FarmBot OS.
         * Downloads and installs if available. */ this.checkUpdates = ()=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "check_updates",
                    args: {
                        package: "farmbot_os"
                    }
                }
            ]));
        };
        /** THIS WILL RESET THE SD CARD, deleting all non-factory data!
         * Be careful!! */ this.resetOS = ()=>{
            return this.publish((0, $2Wyna.rpcRequest)([
                {
                    kind: "factory_reset",
                    args: {
                        package: "farmbot_os"
                    }
                }
            ]));
        };
        /** WARNING: will reset all firmware (hardware) settings! */ this.resetMCU = ()=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "factory_reset",
                    args: {
                        package: "arduino_firmware"
                    }
                }
            ]));
        };
        this.flashFirmware = (/** one of: "arduino"|"express_k10"|"farmduino_k14"|"farmduino" */ firmware_name)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "flash_firmware",
                    args: {
                        package: firmware_name
                    }
                }
            ]));
        };
        /**
         * Lock the bot from moving (E-STOP). Turns off peripherals and motors. This
         * also will pause running regimens and cause any running sequences to exit.
         */ this.emergencyLock = ()=>{
            const body = [
                {
                    kind: "emergency_lock",
                    args: {}
                }
            ];
            const rpc = (0, $2Wyna.rpcRequest)(body, (0, $2Wyna.Priority).HIGHEST);
            return this.send(rpc);
        };
        /** Unlock the bot when the user says it is safe. */ this.emergencyUnlock = ()=>{
            const body = [
                {
                    kind: "emergency_unlock",
                    args: {}
                }
            ];
            const rpc = (0, $2Wyna.rpcRequest)(body, (0, $2Wyna.Priority).HIGHEST);
            return this.send(rpc);
        };
        /** Execute a sequence by its ID on the FarmBot API. */ this.execSequence = (sequence_id, body = [])=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "execute",
                    args: {
                        sequence_id: sequence_id
                    },
                    body: body
                }
            ]));
        };
        /** Run an installed Farmware plugin on the SD Card. */ this.execScript = (/** Name of the Farmware. */ label, /** Optional ENV vars to pass the Farmware. */ envVars)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "execute_script",
                    args: {
                        label: label
                    },
                    body: envVars
                }
            ]));
        };
        /** Bring a particular axis (or all of them) to position 0 in Z Y X order. */ this.home = (args)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "home",
                    args: args
                }
            ]));
        };
        /** Use end stops or encoders to figure out where 0,0,0 is in Z Y X axis
         * order. WON'T WORK WITHOUT ENCODERS OR END STOPS! A blockage or stall
         * during this command will set that position as zero. Use carefully. */ this.findHome = (args)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "find_home",
                    args: args
                }
            ]));
        };
        /** Move FarmBot to an absolute point. */ this.moveAbsolute = (args)=>{
            const { x: x, y: y, z: z } = args;
            const speed = args.speed || (0, $lYlQL.CONFIG_DEFAULTS).speed;
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "move_absolute",
                    args: {
                        location: (0, $d3ujF.coordinate)(x, y, z),
                        offset: (0, $d3ujF.coordinate)(0, 0, 0),
                        speed: speed
                    }
                }
            ]));
        };
        /** Move FarmBot to position relative to its current position. */ this.moveRelative = (args)=>{
            const { x: x, y: y, z: z } = args;
            const speed = args.speed || (0, $lYlQL.CONFIG_DEFAULTS).speed;
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "move_relative",
                    args: {
                        x: x,
                        y: y,
                        z: z,
                        speed: speed
                    }
                }
            ]));
        };
        /** Set a GPIO pin to a particular value. */ this.writePin = (args)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "write_pin",
                    args: args
                }
            ]));
        };
        /** Read the value of a GPIO pin. Will create a SensorReading if it's
         * a sensor. */ this.readPin = (args)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "read_pin",
                    args: args
                }
            ]));
        };
        /** Reverse the value of a digital pin. */ this.togglePin = (args)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "toggle_pin",
                    args: args
                }
            ]));
        };
        /** Read the status of the bot. Should not be needed unless you are first
         * logging in to the device, since the device pushes new states out on
         * every update. */ this.readStatus = (args = {})=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "read_status",
                    args: args
                }
            ]));
        };
        /** Snap a photo and send to the API for post processing. */ this.takePhoto = (args = {})=>this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "take_photo",
                    args: args
                }
            ]));
        /** Download/apply all of the latest FarmBot API JSON resources (plants,
         * account info, etc.) to the device. */ this.sync = (args = {})=>this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "sync",
                    args: args
                }
            ]));
        /**
         * Set the current position of the given axis to 0.
         * Example: Sending `bot.setZero("x")` at x: 255 will translate position
         * 255 to 0, causing that position to be x: 0.
         */ this.setZero = (axis)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "zero",
                    args: {
                        axis: axis
                    }
                }
            ]));
        };
        /**
         * Set user ENV vars (usually used by 3rd-party Farmware plugins).
         * Set value to `undefined` to unset.
         */ this.setUserEnv = (configs)=>{
            const body = Object.keys(configs).map(function(label) {
                return {
                    kind: "pair",
                    args: {
                        label: label,
                        value: configs[label] || (0, $7nBDP.Misc).NULL
                    }
                };
            });
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "set_user_env",
                    args: {},
                    body: body
                }
            ]));
        };
        this.sendMessage = (message_type, message, channels = [])=>{
            this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "send_message",
                    args: {
                        message_type: message_type,
                        message: message
                    },
                    body: channels.map((channel_name)=>({
                            kind: "channel",
                            args: {
                                channel_name: channel_name
                            }
                        }))
                }
            ]));
        };
        /** Control servos on pins 4 and 5. */ this.setServoAngle = (args)=>{
            const result = this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "set_servo_angle",
                    args: args
                }
            ]));
            // Celery script can't validate `pin_number` and `pin_value` the way we need
            // for `set_servo_angle`. We will send the RPC command off, but also
            // crash the client to aid debugging.
            if (![
                4,
                5,
                6,
                11
            ].includes(args.pin_number)) throw new Error("Servos only work on pins 4 and 5");
            if (args.pin_value > 180 || args.pin_value < 0) throw new Error("Pin value outside of 0...180 range");
            return result;
        };
        /**
         * Find the axis extents using encoder, motor, or end-stop feedback.
         * Will set a new home position and a new axis length for the given axis.
         */ this.calibrate = (args)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "calibrate",
                    args: args
                }
            ]));
        };
        this.lua = (lua)=>{
            return this.send((0, $2Wyna.rpcRequest)([
                {
                    kind: "lua",
                    args: {
                        lua: lua
                    }
                }
            ]));
        };
        /**
         * Retrieves all of the event handlers for a particular event.
         * Returns an empty array if the event did not exist.
         */ this.event = (name)=>{
            this._events[name] = this._events[name] || [];
            return this._events[name];
        };
        this.on = (event, value, once = false)=>{
            this.event(event).push({
                value: value,
                once: once,
                event: event
            });
        };
        this.emit = (event, data)=>{
            const nextArray = [];
            this.event(event).concat(this.event("*")).forEach(function(handler) {
                try {
                    handler.value(data, event);
                    if (!handler.once && handler.event === event) nextArray.push(handler);
                } catch (e) {
                    const msg = `Exception thrown while handling '${event}' event.`;
                    console.warn(msg);
                    console.dir(e);
                }
            });
            if (nextArray.length === 0) delete this._events[event];
            else this._events[event] = nextArray;
        };
        /** Low-level means of sending MQTT packets. Does not check format. Does not
         * acknowledge confirmation. Probably not the one you want. */ this.publish = (msg, important = true)=>{
            if (this.client) {
                this.emit((0, $7nBDP.FbjsEventName).sent, msg);
                /** SEE: https://github.com/mqttjs/MQTT.js#client */ this.client.publish(this.channel.toDevice, JSON.stringify(msg));
            } else {
                if (important) throw new Error("Not connected to server");
            }
        };
        /** Low-level means of sending MQTT RPC commands to the bot. Acknowledges
         * receipt of message, but does not check formatting. Consider using higher
         * level methods like .moveRelative(), .calibrate(), etc....
        */ this.send = (input)=>{
            return new Promise((resolve, reject)=>{
                this.publish(input);
                function handler(response) {
                    switch(response.kind){
                        case "rpc_ok":
                            return resolve(response);
                        case "rpc_error":
                            const reason = (response.body || []).map((x)=>x.args.message).join(", ");
                            return reject(new Error(reason));
                        default:
                            console.dir(response);
                            throw new Error("Got a bad CeleryScript node.");
                    }
                }
                this.on(input.args.label, handler, true);
            });
        };
        /** Main entry point for all MQTT packets. */ this._onmessage = (chan, buffer)=>{
            const original = (0, $el3kn.bufferToString)(buffer);
            const segments = chan.split((0, $7nBDP.Misc).MQTT_DELIM);
            const { emit: emit } = this;
            try {
                const msg = JSON.parse(original);
                if (segments[0] == (0, $7nBDP.MqttChanName).publicBroadcast) return emit((0, $7nBDP.MqttChanName).publicBroadcast, msg);
                switch(segments[2]){
                    case (0, $7nBDP.MqttChanName).logs:
                        return emit((0, $7nBDP.FbjsEventName).logs, msg);
                    case (0, $7nBDP.MqttChanName).status:
                        return emit((0, $7nBDP.FbjsEventName).status, msg);
                    case (0, $7nBDP.MqttChanName).sync:
                        return emit((0, $7nBDP.FbjsEventName).sync, msg);
                    case (0, $7nBDP.MqttChanName).pong:
                        return emit(segments[3], msg);
                    default:
                        const ev = (0, $g4iX8.hasLabel)(msg) ? msg.args.label : (0, $7nBDP.FbjsEventName).malformed;
                        return emit(ev, msg);
                }
            } catch (error) {
                console.dir({
                    text: "Could not parse inbound message from MQTT.",
                    error: error
                });
                emit((0, $7nBDP.FbjsEventName).malformed, original);
            }
        };
        this.ping = (timeout = 10000, now = (0, $7L8KP.timestamp)())=>{
            this.setConfig("LAST_PING_OUT", now);
            return this.doPing(now, timeout);
        };
        // STEP 0: Subscribe to `bot/device_23/pong/#`
        // STEP 0: Send         `bot/device_23/ping/3123123`
        // STEP 0: Receive      `bot/device_23/pong/3123123`
        this.doPing = (startedAt, timeout)=>{
            const timeoutPromise = new Promise((_, rej)=>setTimeout(()=>rej(-0), timeout));
            const pingPromise = new Promise((res, _)=>{
                const ok = ()=>{
                    const t = (0, $7L8KP.timestamp)();
                    this.setConfig("LAST_PING_IN", t);
                    res(t - startedAt);
                };
                this.on("" + startedAt, ok, true);
                const chan = this.channel.ping(startedAt);
                if (this.client) this.client.publish(chan, JSON.stringify(startedAt));
            });
            return Promise.race([
                timeoutPromise,
                pingPromise
            ]);
        };
        /** Bootstrap the device onto the MQTT broker. */ this.connect = ()=>{
            const { mqttUsername: mqttUsername, token: token, mqttServer: mqttServer } = this.config;
            const reconnectPeriod = (0, $7nBDP.Misc).RECONNECT_THROTTLE_MS;
            const client = (0, ($parcel$interopDefault($eSX5Q$mqtt))).connect(mqttServer, {
                clean: true,
                clientId: `FBJS-${$e5fff2f6d9c58e21$export$3ab9a2df6016a88a.VERSION}-${(0, $bu5Qj.uuid)()}`,
                password: token,
                protocolId: "MQTT",
                protocolVersion: 4,
                reconnectPeriod: reconnectPeriod,
                username: mqttUsername
            });
            this.client = client;
            this.resources = new (0, $c7gS9.ResourceAdapter)(this, this.config.mqttUsername);
            client.on("message", this._onmessage);
            client.on("offline", ()=>this.emit((0, $7nBDP.FbjsEventName).offline, {}));
            client.on("connect", ()=>this.emit((0, $7nBDP.FbjsEventName).online, {}));
            const channels = [
                this.channel.logs,
                this.channel.status,
                this.channel.sync,
                this.channel.toClient,
                this.channel.pong
            ];
            client.subscribe(channels);
            return new Promise((resolve, _reject)=>{
                if (this.client) this.client.once("connect", ()=>resolve(this));
                else throw new Error("Please connect first.");
            });
        };
        this._events = {};
        this.config = (0, $lYlQL.generateConfig)(input);
        this.resources = new (0, $c7gS9.ResourceAdapter)(this, this.config.mqttUsername);
    }
    /** Dictionary of all relevant MQTT channels the bot uses. */ get channel() {
        const deviceName = this.config.mqttUsername;
        return {
            /** From the browser, usually. */ toDevice: `bot/${deviceName}/${(0, $7nBDP.MqttChanName).fromClients}`,
            /** From farmbot */ toClient: `bot/${deviceName}/${(0, $7nBDP.MqttChanName).fromDevice}`,
            status: `bot/${deviceName}/${(0, $7nBDP.MqttChanName).status}`,
            logs: `bot/${deviceName}/${(0, $7nBDP.MqttChanName).logs}`,
            sync: `bot/${deviceName}/${(0, $7nBDP.MqttChanName).sync}/#`,
            /** Read only */ pong: `bot/${deviceName}/pong/#`,
            /** Write only: bot/${deviceName}/ping/${timestamp} */ ping: (tStamp)=>`bot/${deviceName}/ping/${tStamp}`
        };
    }
}
$e5fff2f6d9c58e21$export$3ab9a2df6016a88a.VERSION = "15.10.1";

});
parcelRegister("el3kn", function(module, exports) {

$parcel$export(module.exports, "stringToBuffer", () => $a7059ba78750de09$export$1e95461c937e230d);
$parcel$export(module.exports, "bufferToString", () => $a7059ba78750de09$export$4f75cc6593308bd6);

var $d3ujF = parcelRequire("d3ujF");

var $g4iX8 = parcelRequire("g4iX8");

var $cobLS = parcelRequire("cobLS");

var $Az9Ui = parcelRequire("Az9Ui");

var $2Wyna = parcelRequire("2Wyna");

var $bu5Qj = parcelRequire("bu5Qj");
function $a7059ba78750de09$export$1e95461c937e230d(str) {
    const regular_array = str.split("").map((x)=>x.charCodeAt(0));
    const data16 = new Uint8Array(regular_array);
    return data16;
}
function $a7059ba78750de09$var$newDecoder() {
    if (typeof util !== "undefined" && util.TextDecoder) return new util.TextDecoder();
    if (typeof window !== "undefined" && window.TextDecoder) return new window.TextDecoder();
    return {
        decode (buffer) {
            const chars = [];
            buffer.forEach((x)=>chars.push(String.fromCharCode(x)));
            return chars.join("");
        }
    };
}
const $a7059ba78750de09$var$td = $a7059ba78750de09$var$newDecoder();
const $a7059ba78750de09$export$4f75cc6593308bd6 = (b)=>$a7059ba78750de09$var$td.decode(b);
$parcel$exportWildcard(module.exports, $d3ujF);
$parcel$exportWildcard(module.exports, $g4iX8);
$parcel$exportWildcard(module.exports, $cobLS);
$parcel$exportWildcard(module.exports, $Az9Ui);
$parcel$exportWildcard(module.exports, $2Wyna);
$parcel$exportWildcard(module.exports, $bu5Qj);

});
parcelRegister("d3ujF", function(module, exports) {

$parcel$export(module.exports, "coordinate", () => $9813125a16a2b793$export$bf56ff1a05c69b9a);
function $9813125a16a2b793$export$bf56ff1a05c69b9a(x, y, z) {
    return {
        kind: "coordinate",
        args: {
            x: x,
            y: y,
            z: z
        }
    };
}

});

parcelRegister("g4iX8", function(module, exports) {

$parcel$export(module.exports, "isCeleryScript", () => $bb2bb8b474f7133e$export$7b28645421dfad14);
$parcel$export(module.exports, "hasLabel", () => $bb2bb8b474f7133e$export$939ea909fc0c90e4);
const $bb2bb8b474f7133e$var$isObj = (o)=>!!(o && typeof o === "object");
const $bb2bb8b474f7133e$var$hasKind = (o)=>typeof o.kind === "string";
const $bb2bb8b474f7133e$var$hasArgs = (o)=>$bb2bb8b474f7133e$var$isObj(o) && !!o.args;
function $bb2bb8b474f7133e$export$7b28645421dfad14(x) {
    return $bb2bb8b474f7133e$var$isObj(x) && $bb2bb8b474f7133e$var$hasKind(x) && $bb2bb8b474f7133e$var$hasArgs(x);
}
function $bb2bb8b474f7133e$export$939ea909fc0c90e4(x) {
    if ($bb2bb8b474f7133e$export$7b28645421dfad14(x)) return typeof x.args.label === "string";
    else return false;
}

});

parcelRegister("cobLS", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $9050db6de2440121$export$8ee0fc9ee280b4ee);
function $9050db6de2440121$export$8ee0fc9ee280b4ee() {
    return typeof window === "undefined";
}

});

parcelRegister("Az9Ui", function(module, exports) {

$parcel$export(module.exports, "pick", () => $06dea2b61584185b$export$357523c63a2253b9);
function $06dea2b61584185b$export$357523c63a2253b9(target, value, fallback) {
    const result = target[value];
    return result;
}

});

parcelRegister("2Wyna", function(module, exports) {

$parcel$export(module.exports, "Priority", () => $224ba93982138899$export$300334f671c43555);
$parcel$export(module.exports, "rpcRequest", () => $224ba93982138899$export$d6d466271de85642);

var $bu5Qj = parcelRequire("bu5Qj");
var $224ba93982138899$export$300334f671c43555;
(function(Priority) {
    Priority[Priority["HIGHEST"] = 9000] = "HIGHEST";
    Priority[Priority["NORMAL"] = 600] = "NORMAL";
    Priority[Priority["LOWEST"] = 300] = "LOWEST";
})($224ba93982138899$export$300334f671c43555 || ($224ba93982138899$export$300334f671c43555 = {}));
const $224ba93982138899$export$d6d466271de85642 = (body, priority = $224ba93982138899$export$300334f671c43555.NORMAL)=>({
        kind: "rpc_request",
        args: {
            label: (0, $bu5Qj.uuid)(),
            priority: priority
        },
        body: body
    });

});
parcelRegister("bu5Qj", function(module, exports) {

$parcel$export(module.exports, "uuid", () => $85c7074cb057af20$export$31b40729666a4ae0);
function $85c7074cb057af20$export$31b40729666a4ae0() {
    const template = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    const replaceChar = function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    };
    return template.replace(/[xy]/g, replaceChar);
}

});



parcelRegister("lYlQL", function(module, exports) {

$parcel$export(module.exports, "CONFIG_DEFAULTS", () => $fff0268c4f32afc1$export$429fe2716bb77ce4);
$parcel$export(module.exports, "generateConfig", () => $fff0268c4f32afc1$export$2eafab8a593352a4);
parcelRequire("el3kn");
var $cobLS = parcelRequire("cobLS");
const $fff0268c4f32afc1$var$ERR_TOKEN_PARSE = "Unable to parse token. Is it properly formatted?";
const $fff0268c4f32afc1$export$429fe2716bb77ce4 = {
    speed: 100
};
const $fff0268c4f32afc1$var$ERR_MISSING_MQTT_USERNAME = "MISSING_MQTT_USERNAME";
const $fff0268c4f32afc1$export$ddc74f6374f2ef10 = `NOTE TO NODEJS USERS:

This library requires an 'atob()' function.
Please fix this first.
SOLUTION: https://github.com/FarmBot/farmbot-js/issues/33`;
const $fff0268c4f32afc1$var$parseToken = (input)=>{
    try {
        return JSON.parse(atob(input.split(".")[1]));
    } catch (e) {
        console.warn(e);
        throw new Error($fff0268c4f32afc1$var$ERR_TOKEN_PARSE);
    }
};
const $fff0268c4f32afc1$export$2eafab8a593352a4 = (input)=>{
    if ((0, $cobLS.isNode)() && !$parcel$global.atob) throw new Error($fff0268c4f32afc1$export$ddc74f6374f2ef10);
    const t = $fff0268c4f32afc1$var$parseToken(input.token);
    return {
        speed: input.speed || $fff0268c4f32afc1$export$429fe2716bb77ce4.speed,
        token: input.token,
        secure: input.secure === false ? false : true,
        mqttServer: (0, $cobLS.isNode)() ? `mqtt://${t.mqtt}:1883` : t.mqtt_ws,
        mqttUsername: t.bot || $fff0268c4f32afc1$var$ERR_MISSING_MQTT_USERNAME,
        LAST_PING_OUT: 0,
        LAST_PING_IN: 0
    };
};

});

parcelRegister("c7gS9", function(module, exports) {

$parcel$export(module.exports, "ResourceAdapter", () => $8d233a0248713266$export$61d38aff960bd05b);
parcelRequire("b3Gr5");
var $bu5Qj = parcelRequire("bu5Qj");

var $a32Lo = parcelRequire("a32Lo");

var $adIE7 = parcelRequire("adIE7");
class $8d233a0248713266$export$61d38aff960bd05b {
    constructor(parent, username){
        this.parent = parent;
        this.username = username;
        this.destroy = (r)=>{
            const { client: client } = this.parent;
            return client ? this.doDestroy(client, r.kind, r.id) : (0, $adIE7.rejectRpc)();
        };
        this.save = (resource)=>{
            const { client: client } = this.parent;
            return client ? this.doSave(client, resource) : (0, $adIE7.rejectRpc)();
        };
        this.destroyAll = (req)=>Promise.all(req.map((r)=>this.destroy(r)));
        this.doDestroy = (client, kind, id)=>{
            return new Promise((res, rej)=>{
                const requestId = (0, $bu5Qj.uuid)();
                this.parent.on(requestId, (0, $a32Lo.resolveOrReject)(res, rej));
                client.publish((0, $a32Lo.outboundChanFor)(this.username, "destroy", kind, requestId, id), "");
            });
        };
        this.doSave = (client, r)=>{
            return new Promise((res, rej)=>{
                const uid = (0, $bu5Qj.uuid)();
                this.parent.on(uid, (0, $a32Lo.resolveOrReject)(res, rej));
                const chan = (0, $a32Lo.outboundChanFor)(this.username, "save", r.kind, uid, r.body.id);
                client.publish(chan, JSON.stringify(r.body));
            });
        };
    }
}

});
parcelRegister("a32Lo", function(module, exports) {

$parcel$export(module.exports, "outboundChanFor", () => $750c53f8092874b9$export$282f68fea638d11);
$parcel$export(module.exports, "internalError", () => $750c53f8092874b9$export$bcbf15ce904d591a);
$parcel$export(module.exports, "resolveOrReject", () => $750c53f8092874b9$export$cbefd47f9f016f08);
const $750c53f8092874b9$export$282f68fea638d11 = (username, op, kind, uuid, id = 0)=>{
    const segments = [
        `bot`,
        username,
        `resources_v0`,
        op,
        kind,
        uuid,
        id
    ];
    return segments.join("/");
};
const $750c53f8092874b9$export$bcbf15ce904d591a = {
    kind: "rpc_error",
    args: {
        label: "BROWSER_LEVEL_FAILURE"
    },
    body: [
        {
            kind: "explanation",
            args: {
                message: "Tried to perform batch operation before connect."
            }
        }
    ]
};
const $750c53f8092874b9$export$cbefd47f9f016f08 = (res, rej)=>{
    return (m)=>(m.kind == "rpc_ok" ? res : rej)(m);
};

});

parcelRegister("adIE7", function(module, exports) {

$parcel$export(module.exports, "rejectRpc", () => $770dc012daf1bcbe$export$d53e1703f9959ce0);

var $a32Lo = parcelRequire("a32Lo");
const $770dc012daf1bcbe$export$d53e1703f9959ce0 = ()=>Promise.reject((0, $a32Lo.internalError));

});


parcelRegister("7nBDP", function(module, exports) {

$parcel$export(module.exports, "MqttChanName", () => $55f7e12cfe07bcb9$export$51316fc5e371191b);
$parcel$export(module.exports, "FbjsEventName", () => $55f7e12cfe07bcb9$export$9758e930bdf73341);
$parcel$export(module.exports, "Misc", () => $55f7e12cfe07bcb9$export$4b3033a0406d3b);
var $55f7e12cfe07bcb9$export$51316fc5e371191b;
(function(MqttChanName) {
    MqttChanName["fromApi"] = "from_api";
    MqttChanName["fromClients"] = "from_clients";
    MqttChanName["fromDevice"] = "from_device";
    MqttChanName["logs"] = "logs";
    MqttChanName["status"] = "status";
    MqttChanName["sync"] = "sync";
    /** THIS ONE IS SPECIAL. */ MqttChanName["publicBroadcast"] = "public_broadcast";
    MqttChanName["pong"] = "pong";
})($55f7e12cfe07bcb9$export$51316fc5e371191b || ($55f7e12cfe07bcb9$export$51316fc5e371191b = {}));
var $55f7e12cfe07bcb9$export$9758e930bdf73341;
(function(FbjsEventName) {
    /** State tree update. */ FbjsEventName["status"] = "status";
    /** When a log is received */ FbjsEventName["logs"] = "logs";
    /** When an unexpected message is received */ FbjsEventName["malformed"] = "malformed";
    /** Unreliable. */ FbjsEventName["offline"] = "offline";
    /** Fired on connect. */ FbjsEventName["online"] = "online";
    /** Fires when the API sends an MQTT message to users. */ FbjsEventName["publicBroadcast"] = "public_broadcast";
    /** Fires after any message is sent from current client. */ FbjsEventName["sent"] = "sent";
    /** Used by resource auto-sync. */ FbjsEventName["sync"] = "sync";
    /** When a key is removed from the device state tree. */ FbjsEventName["remove"] = "remove";
})($55f7e12cfe07bcb9$export$9758e930bdf73341 || ($55f7e12cfe07bcb9$export$9758e930bdf73341 = {}));
var $55f7e12cfe07bcb9$export$4b3033a0406d3b;
(function(Misc) {
    /** Channel delimiter for MQTT channels. */ Misc["MQTT_DELIM"] = "/";
    /** A null value when dealing with empty `pair` nodes in CeleryScript. */ Misc["NULL"] = "null";
    /** Reconnect interval for MQTT.js */ Misc[Misc["RECONNECT_THROTTLE_MS"] = 1000] = "RECONNECT_THROTTLE_MS";
})($55f7e12cfe07bcb9$export$4b3033a0406d3b || ($55f7e12cfe07bcb9$export$4b3033a0406d3b = {}));

});

parcelRegister("7L8KP", function(module, exports) {

$parcel$export(module.exports, "timestamp", () => $5a63b69a562da0b9$export$fc00ee57782020aa);
/** Returns a timestamp in ms. */ function $5a63b69a562da0b9$export$fc00ee57782020aa() {
    return Math.round(new Date().getTime() / 100);
} // type RejectFn = (reason?: any) => void;
 // type ResolveFn<T> = (value?: T | PromiseLike<T>) => void;
 // interface Executor<T> {
 //   (x: (resolve: ResolveFn<T>, reject: RejectFn) => void): Promise<T>;
 // }
 // export function timeoutPromise<T>(time: number, executor: Executor<T>): Promise<T> {
 //   return new Promise(executor);
 // }

});


parcelRegister("kgNDz", function(module, exports) {

$parcel$export(module.exports, "Encoder", () => $ec1bce32b88b47c6$export$a50aceb0e02a00aa);
var $ec1bce32b88b47c6$export$a50aceb0e02a00aa;
(function(Encoder) {
    Encoder[Encoder["unknown"] = -1] = "unknown";
    Encoder[Encoder["quadrature"] = 0] = "quadrature";
    Encoder[Encoder["differential"] = 1] = "differential";
})($ec1bce32b88b47c6$export$a50aceb0e02a00aa || ($ec1bce32b88b47c6$export$a50aceb0e02a00aa = {}));

});

parcelRegister("hWgEQ", function(module, exports) {

$parcel$export(module.exports, "SpecialStatus", () => $d0f4c65bea4e3bbe$export$d3ccc720d6d43811);
/** Denotes special status of resource */ var $d0f4c65bea4e3bbe$export$d3ccc720d6d43811;
(function(SpecialStatus) {
    /** The local copy is different than the one on the remote end. */ SpecialStatus["DIRTY"] = "DIRTY";
    /** The local copy is being saved on the remote end right now? */ SpecialStatus["SAVING"] = "SAVING";
    /** API and FE are in sync. Using "" for now because its falsey like old
     * `undefined` value */ SpecialStatus["SAVED"] = "";
})($d0f4c65bea4e3bbe$export$d3ccc720d6d43811 || ($d0f4c65bea4e3bbe$export$d3ccc720d6d43811 = {}));

});


// This is a stub for developers who do not have a module loader or are
// prototyping one-off scripts in a browser.

window.fbjs = (parcelRequire("b3Gr5"));


//# sourceMappingURL=farmbot_single_file.js.map
